export function downloadBlob(data, filename, mimeType) {
    var blob = data instanceof Blob
        ? data
        : new Blob([data], mimeType ? { type: mimeType } : undefined);
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank');
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
export function parseArrayBufferError(errorData) {
    if (!errorData)
        return {};
    try {
        return JSON.parse(new TextDecoder().decode(errorData));
    }
    catch (_a) {
        return {};
    }
}
